import { render } from "./LogoSystem.vue?vue&type=template&id=7ee80b5f&scoped=true"
const script = {}

import "./LogoSystem.vue?vue&type=style&index=0&id=7ee80b5f&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee80b5f"]])

export default __exports__